var React = require('react');

function ActiveUser (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 10C14.2091 10 16 8.20914 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 8.20914 9.79086 10 12 10Z","stroke":"#333333","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M21 22C21 17.0294 16.9706 13 12 13C7.02945 13 3 17.0294 3 22","stroke":"#333333","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M15 18L11 22L9 20","stroke":"#333333","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

ActiveUser.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ActiveUser;

ActiveUser.default = ActiveUser;
